import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class MemberId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): MemberId {
    if (!(value.length > 0)) {
      throw new Error('内容が入力されていません');
    }
    return new MemberId(value);
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
